import React from 'react';
import { Field, ErrorMessage } from 'formik';

const ReviewTab = ({ formData, formConfig, values, setFieldValue }) => {
  return (
    <div className="review-tab">
      <h2 className="tab-title">Review & Submit</h2>
      <p className="review-description">
        Please review your information before submitting the enrollment form.
      </p>

      <div className="review-sections">
        {/* {formConfig.tabs.map((tab, tabIndex) => (
          <div key={tabIndex} className="review-section">
            <h3 className="section-title">{tab.title}</h3>
            
            <div className="section-fields">
              {tab.fields.map((field, fieldIndex) => {
                // Skip dependent fields that shouldn't be shown
                if (field.dependsOn) {
                  const { dependsOn } = field;
                  const shouldRender = formData[dependsOn.field] === dependsOn.value;
                  
                  if (!shouldRender) {
                    return null;
                  }
                }
                
                // Skip signature and file upload fields in the review (they'll be shown separately)
                if (field.type === 'signature' || field.type === 'fileUpload') {
                  return null;
                }
                
                // Format the field value for display
                let displayValue = formData[field.name] || '';
                
                if (field.type === 'checkbox') {
                  displayValue = displayValue ? 'Yes' : 'No';
                }
                
                return (
                  <div key={fieldIndex} className="review-field">
                    <span className="field-label">{field.label}:</span>
                    <span className="field-value">{displayValue}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ))} */}

        {formConfig.tabs.map((tab, tabIndex) => {
          // Filter out fields that should be skipped
          const visibleFields = tab.fields.filter(field => {
            // Skip field types that shouldn't be shown
            if (['signature', 'fileUpload'].includes(field.type)) return false;

            // ✅ Skip review checkbox like termsAgreed
            if (field.name === 'termsAgreed') return false;

            // Handle dependent visibility
            if (field.dependsOn) {
              const { field: depField, value: depValue, includeIn } = field.dependsOn;
              const targetValue = formData[depField];

              let shouldRender = false;
              if (includeIn === "multiselect" && Array.isArray(targetValue)) {
                shouldRender = targetValue.includes(depValue);
              } else {
                shouldRender = targetValue === depValue;
              }

              if (!shouldRender) return false;
            }

            return true;
          });


          // Skip section if no visible fields
          if (visibleFields.length === 0) return null;
          const PLACEHOLDER_LABELS = ['Any other medical conditions', 'Other'];

          return (
            <div key={tabIndex} className="review-section">
              <h3 className="section-title">{tab.title}</h3>
              <div className="section-fields">
                {visibleFields.map((field, fieldIndex) => {
                  let displayValue = formData[field.name] || '';

                  if (field.type === 'checkbox') {
                    displayValue = displayValue ? 'Yes' : 'No';
                  } else if (Array.isArray(displayValue)) {
                    const cleanedArray = displayValue.filter(item => item !== "Any other medical conditions");
                    displayValue = cleanedArray.join(', ');
                  } else if (field.type === 'date' && displayValue) {
                    displayValue = new Date(displayValue).toLocaleDateString('en-GB').split('/').join('-');
                  }


                  return (
                    <div key={fieldIndex} className="review-field">
                      <span className="field-label">{field.label}:</span>
                      <span className="field-value">{displayValue}</span>
                    </div>
                  );
                })}

              </div>
            </div>
          );
        })}

      </div>

   

      {/* Final agreement and signature */}
      <div className="final-agreement">
        <div className="form-field checkbox-field">
          <label className="checkbox-label">
            <Field
              type="checkbox"
              name="termsAgreed"
              className="checkbox-input"
            />
            <span className="checkbox-text">
              I confirm that all the information provided is accurate and complete.
              I agree to the terms and conditions of the dental insurance policy.
            </span>
          </label>

          <ErrorMessage
            name="termsAgreed"
            component="div"
            className="error-message"
          />
        </div>

        {/* Signature field will be handled by the FormField component */}
        {formConfig.tabs[formConfig.tabs.length - 1].fields
          .filter(field => field.type === 'signature')
          .map((field, index) => (
            <div key={index} className="signature-review">
              <h4>{field.label}</h4>
              {formData[field.name] ? (
                <div className="signature-image-container">
                  <img
                    src={formData[field.name]}
                    alt="Signature"
                    className="signature-image"
                  />
                </div>
              ) : (
                <div className="signature-placeholder">
                  Please sign before submitting
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default ReviewTab;
